

exports.__esModule = true;
exports.venmoExperience = exports.venmoInfo = exports.VENMO_OPTIONS = undefined;

var _angular = require('angular');

var _index = require('xo-device-info/dist/index');

var _squid = require('squid');

var _auth = require('xo-models/src/auth');

var _checkout = require('xo-models/src/checkout');

var _sessionStorage = require('./sessionStorage');

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Decide if Venmo header should be shown
// TODO: Check how the cookie should be read/set (through meta? if read on server side)
var PWV_COOKIE = 'pwv';
var VENMO_SETUP_COOKIE = 'venmoSetup';

var VENMO_OPTIONS = exports.VENMO_OPTIONS = {
    PAYPAL: 'PAYPAL',
    VENMO: 'VENMO'
};

var venmoInfo = exports.venmoInfo = {
    // Handler to call to determine if user can use Venmo
    isVenmo: function isVenmo() {

        var venmoRegex = new RegExp('(?:^|; )' + PWV_COOKIE + '=1(?:;|$)');
        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);

        var merchantCountry = appData.merchant.merchant_country;
        var isProcessorDeclined = appData.flags.processor_declined;
        var isOrderTransaction = cart.payment_action === 'order';

        var isMobile = _index.$DeviceInfo.isDevice();
        var isVenmoCookiePresent = document.cookie.match(venmoRegex);

        return Boolean(_squid.$util.param('isVenmo') || isVenmoCookiePresent && isMobile && !isProcessorDeclined && !isOrderTransaction && merchantCountry === 'US');
    },


    // Get option user has selected for Venmo, return null if user has not set up yet.
    venmoState: function venmoState() {
        var setupRegex = new RegExp('(?:^|; )' + VENMO_SETUP_COOKIE + '=(\\w*)(?:;|$)');
        var match = document.cookie.match(setupRegex);

        if (match && VENMO_OPTIONS.hasOwnProperty(match[1])) {
            return match[1];
        } else {
            return null;
        }
    },


    // Delete the venmo state cookie
    clearVenmoState: function clearVenmoState() {
        document.cookie = VENMO_SETUP_COOKIE + '=; Max-Age=0';
    },
    setVenmoCookie: function setVenmoCookie() {
        document.cookie = VENMO_SETUP_COOKIE + '=' + VENMO_OPTIONS.VENMO;
    },
    setPayPalCookie: function setPayPalCookie() {
        document.cookie = VENMO_SETUP_COOKIE + '=' + VENMO_OPTIONS.PAYPAL;
    },


    // Build the venmo URL scheme
    buildVenmoURL: function buildVenmoURL() {
        var SCHEME = 'https://venmo.com/';
        var VENMO_ROUTE = '#/checkout/venmo';
        var LOGIN_ROUTE = '#/checkout/login';

        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);

        var params = (0, _angular.$httpParamSerializer)({
            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
            'ua': _angular.$window.navigator.userAgent,
            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
            'token': _angular.$rootScope.token,
            'total': cartModel.purchase.amounts.total.amount,
            'currency': cartModel.purchase.amounts.total.currency_code
        });

        return SCHEME + 'paypal/checkout?' + params;
    }
};

var venmoExperienceKey = 'VENMO_EXPERIENCE';

// Get whether a token is marked as Venmo experience.
var venmoExperience = exports.venmoExperience = {
    set: function set(token) {
        try {
            _sessionStorage2['default'].setItem(venmoExperienceKey, token);
        } catch (e) {
            return;
        }
    },
    get: function get(token) {
        var auth = _auth.$AuthModel.instance();
        try {
            if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
            _sessionStorage2['default'].getItem(venmoExperienceKey) === token) {
                return true;
            } else {
                this.set(null);
                return false;
            }
        } catch (e) {
            return false;
        }
    }
};

_angular.$rootScope;

_angular.$window;

_angular.$location;

_angular.$httpParamSerializer;

_index.$DeviceInfo;

_squid.$util;

_auth.$AuthModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;


//////////////////
// WEBPACK FOOTER
// ./components/xo-venmo-components/src/venmo-info/index.js
// module id = ./components/xo-venmo-components/src/venmo-info/index.js
// module chunks = 1